import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { useTheme } from 'styled-components';
import { Dot } from './styled';
export const NotificationIndicator = memo(function NotificationIndicator({ positive, warning, critical, className, dataTestId, }) {
    const { colors } = useTheme();
    const color = useMemo(() => {
        if (critical)
            return colors.critical100;
        if (warning)
            return colors.warning100;
        if (positive)
            return colors.positive100;
        return colors.grey30_1;
    }, [colors, critical, warning, positive]);
    return _jsx(Dot, { className: className, "$color": color, "data-testid": dataTestId });
});
